/**
 * Founder Story video card.
 * Clicking the play button (or the cover) plays the video inside the card and shows
 * the native controls so visitors can pause, seek and change the volume.
 * When the video ends, the cover and play button come back.
 */
class FounderVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('.landing-founder__video');
    this.button = this.querySelector('button.landing-founder__play-btn');
    if (!this.video || !this.button) return;

    this.onPlayClick = () => this.play();
    this.onCoverClick = (e) => {
      if (!this.classList.contains('is-started') && e.target === this.querySelector('.landing-founder__img')) this.play();
    };
    this.onPlay = () => this.classList.add('is-started', 'is-playing');
    this.onPause = () => this.classList.remove('is-playing');
    this.onEnded = () => {
      this.classList.remove('is-started', 'is-playing');
      this.video.controls = false;
      this.video.currentTime = 0;
      this.button.focus({ preventScroll: true });
    };

    this.button.addEventListener('click', this.onPlayClick);
    this.addEventListener('click', this.onCoverClick);
    this.video.addEventListener('play', this.onPlay);
    this.video.addEventListener('pause', this.onPause);
    this.video.addEventListener('ended', this.onEnded);
  }

  disconnectedCallback() {
    this.video?.pause();
  }

  play() {
    this.video.controls = true;
    const playPromise = this.video.play();
    if (playPromise) {
      playPromise
        .then(() => this.video.focus({ preventScroll: true }))
        .catch(() => this.classList.remove('is-started', 'is-playing'));
    }
  }
}

if (!customElements.get('founder-video')) {
  customElements.define('founder-video', FounderVideo);
}
